import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import logo from './extras/recycle_spinner.gif';
import './App.css';
import { useEffect, useState } from 'react';
import Main from './main/Main';

function App() {

  const [loading, setLoading] = useState(true);

  const theme = createTheme();


  useEffect(() => {
    window.setTimeout(() => {
      setLoading(false);
    }, 1000);

  }, [])

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <div className="App">
          {
            loading ? <img src={logo} className="spinner" alt="" /> : <Main />
          }
        </div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
